<template>
    <div class="pb-4">
        <div>
            <h3 style="font-weight: 700;">Hiển thị bộ lọc</h3>
            <el-checkbox :indeterminate="isIndeterminate" size="medium" class="mb-2" v-model="checkAll" @change="handleCheckAllChange">Chọn tất cả</el-checkbox>
        </div>
        <el-row :gutter="20">
            <el-checkbox-group size="medium" v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-col :span="6" class="my-2 fa-2x" v-for="(item, index) in tableColumnItems" :key="index">
                    <el-checkbox v-if="item.key !== 'branch_id' || isGDKV"  :span="6"  :label="item" :key="item.name">{{item.label}}</el-checkbox>
                </el-col>
            </el-checkbox-group>
        </el-row>
        <div class="d-flex justify-content-end mt-3">
            <el-button @click="saveConfig()" :loading="loadingSave">{{ isUpdate ? 'Sửa thông tin' : 'Lưu thông tin' }}</el-button>
        </div>

    </div>
</template>

<script>

import {SERVICE_CONFIG_CUSTOMER_STORE} from "@/core/services/store/service.module";

export default {
    name: "FilterSearch",
    props: {
        tableColumnsOption: {
            type: Object,
        },

        isUpdate: {
            type: Object,
        },

        isGDKV: {
            type: Boolean,
        }
    },
    data() {
        return {
            checkAll: false,
            checkedCities: [{key: "name", label: "Họ tên, số điện thoại"}],
            isIndeterminate: true,
            loadingSave: false,
            tableColumnItems: [
                {key: "name", label: "Họ tên, số điện thoại"},
                {key: "dieu_kien_tai_chinh", label: "Tài chính"},
                {key: "ngay_hen", label: "Ngày hẹn"},
                {key: "sale", label: "Nhân sự"},
                {key: "level", label: "Level"},
                {key: "view_as", label: "Tư cách xem"},
                {key: "nguon", label: "Nguồn"},
                {key: "trang_thai_tu_van", label: "Trạng thái tư vấn"},
                {key: "center", label: "Trung tâm"},
                {key: "hot_key", label: "Phím nóng"},
                {key: "ma_gioi_thieu", label: "Mã/ người giới thiệu"},
                {key: "branch_id", label: "Văn phòng"},
            ]
        };
    },
    mounted() {
        this.tableColumnItems.forEach(item => {
            if (this.tableColumnsOption[item.key] === true) {
                this.checkedCities.push(item);
            }
        });
    },
    methods: {
        handleCheckAllChange(val) {
            this.checkedCities = val ? this.tableColumnItems : [];
            this.isIndeterminate = false;
            this.tableColumnItems.forEach((item) => {
                this.tableColumnsOption[item.key] = !!val;
            });
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.tableColumnItems.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.tableColumnItems.length;
            const removedItems = this.tableColumnItems.filter(item => !value.includes(item));
            const addedItems = value.filter(item => !this.tableColumnItems.includes(item.key));
            removedItems.forEach(item => {
                this.tableColumnsOption[item.key] = false;
            });
            addedItems.forEach(item => {
                this.tableColumnsOption[item.key] = true;
            });
        },
        saveConfig() {
            this.loadingSave = true;
            let data = this.tableColumnsOption;
            this.$store.dispatch(SERVICE_CONFIG_CUSTOMER_STORE, {  detail: data, config_type: 2, model: 'customer'})
                .then(() => {
                    this.loadingSave = true;
                    this.isUpdate = true;
                    this.close();
                    this.$message.success('Lưu cấu hình thành công');
                })
        },
        close() {
            this.$emit('close');
        }
    }
};
</script>

<style scoped>
.el-col {
    font-weight: 500;
}
</style>
